import { Colour, ListItem, useLayout } from '@ukpostbox/frontend-framework';
import { FormatLocaleRelativeStrict } from '@ukpostbox/helpers';
import React from 'react';
import { ActivityRenewalType } from '@ukpostbox/client-data/lib/Types/ClientTypes';
import { faRefresh } from '@fortawesome/pro-solid-svg-icons/faRefresh';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function ActivityEventRenewal(item: ActivityRenewalType) {
	const { currentLocale } = useSite();
	const { isTiny, isSmall } = useLayout();

	return (
		<ListItem
			actionLink={{ url: `./manage-account/payment/transactions` }}
			iconContent={{ icon: faRefresh, iconBg: Colour.Success }}
			title={item.message}
			description={isTiny || isSmall ? FormatLocaleRelativeStrict(item.eventDate, currentLocale) : undefined}
			addonRight={
				!isTiny && !isSmall ? { content: FormatLocaleRelativeStrict(item.eventDate, currentLocale) } : undefined
			}
		/>
	);
}

export { ActivityEventRenewal };
